import { useQuery } from '@tanstack/react-query';
import { createLoyaltyQuery } from '~/services/loyalty/lib';
import { QueryKeys } from '~/services/loyalty/constants';
import { useLoyaltyContext } from '..';
import type { AllowedOptions } from '../allowedQueryOptions';
import type { LoyaltyApiError, ReceiptResponse } from '~/lib/data-contract/loyalty';

export const useReceipt = <TData = ReceiptResponse>(
    systemId: string,
    options?: AllowedOptions<ReceiptResponse, TData>,
) => {
    const { businessCentralId, translate, trackError } = useLoyaltyContext();

    return useQuery<ReceiptResponse, LoyaltyApiError, TData>({
        queryKey: [QueryKeys.PURCHASE_HISTORY, systemId],
        queryFn: createLoyaltyQuery('GetReceipt', translate, trackError, {
            sellToContactNo: businessCentralId,
            systemId,
        }),
        enabled: false,
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 1000 * 30,
        ...options,
    });
};
